import React, { ReactNode, useContext, useState } from "react";
import callApi from "../../components/call-api/call-api";
import { Artist } from "../../types/Artist";
import { getArtistVector, postArtistVector } from "../../components/apis/music-api";
import { AuthenticationContext } from "../../components/authentication/AuthenticationContext";
import { ArtistVector } from "../../types/ArtistVector";
import VectorModalContext from "./VectorModalContext";

interface VectorModalProviderProps {
    children: ReactNode;
}

const VectorModalProvider = (props: VectorModalProviderProps) => {
    const { getAccessToken } = useContext(AuthenticationContext);
    const [ vectorModalOpen, setVectorModalOpen ] = useState<boolean>(false);    
    const [ vector, setVector ] = useState<ArtistVector>({} as ArtistVector);
    const [ artist, setArtist ] = useState<Artist>();

    const applyVector = async (artist: Artist | undefined) => {
        await callApi<ArtistVector>(getArtistVector(getAccessToken(), artist?.name ?? ''), setVector);
        setArtist(artist);
        setVectorModalOpen(true);
    }
    
    const handleSave = async () => {
        await postArtistVector(getAccessToken(), vector);
        setVectorModalOpen(false);
    }

    return (
        <VectorModalContext.Provider value={{
            vector,
            setVector,
            vectorModalOpen,
            setVectorModalOpen,
            applyVector,
            artist,
            handleSave,
        }}>
            {props.children}
        </VectorModalContext.Provider>
    );
}

export default VectorModalProvider;
